import _typeof from "@babel/runtime/helpers/esm/typeof";
import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["withProfile", "withLoyalty"],
    _excluded2 = ["isB2B", "onClose", "onLoginSuccess", "onLoginError", "onLoginTemporary", "onCastSuccess", "language", "registrationHref", "openRegistrationInNewTab", "ssdtpName", "ssdtiName", "ssdcpName", "ssdgeName", "ssdklName", "cookiesDomain", "isModal", "isSocial", "isTemporaryProfile", "stage", "theme", "socialState", "socialApple", "socialFacebook", "socialGoogle", "socialLogin", "socialLoginParameters", "socialOneTap", "socialTinkoff", "socialVk", "socialYandex", "socialButtonsVisible", "oneTap", "temporaryResource", "isRecovery", "recoveryHref", "loginDisabled", "loginHref", "loginHeaderText", "loginBottomText", "loginButtonText", "info", "headers", "headingColor", "openRecoveryInNewTab", "isOpen", "login", "recoveryStep", "recoverySecret", "isAllowedDataIds", "withoutCast", "posGA", "titleSize", "fetchCampaigns", "onRecoverySuccess", "showSuccessRecoverPopupOnMount", "loginFieldProps", "passwordFieldProps", "providerSwitcher", "registerButtonText", "onRegister", "oneSignalUserId"];

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Textfield } from '@s7/ui-kit'; // TODO: DS-1533
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

import UserLinear from '@s7/ui-kit/icons/UserLinear';
import Cookies from 'js-cookie';
import pathOr from 'ramda/src/pathOr';
import propOr from 'ramda/src/propOr';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Auth, Campaigns, cancelSource, getAllowedSocials, setHeaders, setLanguage, setStage } from '../api';
import { setCounterId } from '../utils/analytics/services/yandexMetric';
import { isHtmlInputElement } from '../utils/isHtmlInputElement';
import { dictKeys, getTestIdGetter } from '../utils/testIds';
import Login from '../Login';
import Popup from '../Popup';
import Recovery, { recoverySteps } from '../RecoveryContainer';
import { appendFacebookPlaceholderNode, appendSocialAuthScripts, formatLogin, getDictionary, getErrorFromResponse, getLoginValidator, getSocialProfileData, getSsdge, noop, validateEmail } from '../utils';
import { AnalyticsContextProvider, useAnalyticsContext } from '../utils/analytics';
import { sendMyProfileLoginEvent, sendMyProfileLoginWidgetEvent } from '../utils/GA';
import { initSocials, socialAuth } from '../utils/social';
import { useMediaQuery } from '@s7/ui-kit/hooks';
import { useInitCast } from './useInitCast';
import { useInitLWAPI } from './useInitLWAPI';
export var typesMap = {
  apple: 'APPLE',
  fb: 'FACEBOOK',
  google: 'GOOGLE',
  oneTap: 'GOOGLE',
  tinkoff: 'TINKOFF',
  vk: 'VK',
  yandex: 'YANDEX'
};
export var typesMapGA = {
  fb: 'FACEBOOK',
  google: 'GOOGLE',
  oneTap: 'ONETAP',
  tinkoff: 'TINKOFF',
  vk: 'VK'
};
export var loginTypesGA = {
  '': 'FFP',
  card: 'FFP',
  email: 'EMAIL',
  oneTap: 'ONETAP',
  phone: 'PHONE',
  social: 'SOCIAL'
};
var loginTypes = {
  apple: 'apple_id',
  card: 'ffp',
  email: 'email',
  fb: 'facebook',
  google: 'google',
  oneTap: 'google',
  phone: 'phone',
  tinkoff: 'tinkoff',
  vk: 'vk',
  yandex: 'yandex'
};

var isProfileExistError = function isProfileExistError(error) {
  return error ? ['profile.with.email.already.exists', 'profile.with.phone.already.exists'].indexOf(error.code) !== -1 : false;
};

var isProfileExistByPhoneError = function isProfileExistByPhoneError(error) {
  return error ? error.code === 'profile.with.phone.already.exists' : false;
};

export var LoginWidget = function LoginWidget(_ref) {
  var _ref$withProfile = _ref.withProfile,
      withProfile = _ref$withProfile === void 0 ? false : _ref$withProfile,
      _ref$withLoyalty = _ref.withLoyalty,
      withLoyalty = _ref$withLoyalty === void 0 ? false : _ref$withLoyalty,
      props = _objectWithoutProperties(_ref, _excluded);

  var isB2B = props.isB2B,
      _props$onClose = props.onClose,
      onClose = _props$onClose === void 0 ? noop : _props$onClose,
      _props$onLoginSuccess = props.onLoginSuccess,
      onLoginSuccess = _props$onLoginSuccess === void 0 ? noop : _props$onLoginSuccess,
      _props$onLoginError = props.onLoginError,
      onLoginError = _props$onLoginError === void 0 ? noop : _props$onLoginError,
      _props$onLoginTempora = props.onLoginTemporary,
      onLoginTemporary = _props$onLoginTempora === void 0 ? noop : _props$onLoginTempora,
      _props$onCastSuccess = props.onCastSuccess,
      onCastSuccess = _props$onCastSuccess === void 0 ? noop : _props$onCastSuccess,
      _props$language = props.language,
      language = _props$language === void 0 ? 'ru' : _props$language,
      _props$registrationHr = props.registrationHref,
      registrationHref = _props$registrationHr === void 0 ? 'https://myprofile.s7.ru/registration' : _props$registrationHr,
      _props$openRegistrati = props.openRegistrationInNewTab,
      openRegistrationInNewTab = _props$openRegistrati === void 0 ? false : _props$openRegistrati,
      _props$ssdtpName = props.ssdtpName,
      ssdtpName = _props$ssdtpName === void 0 ? 'ssdtp' : _props$ssdtpName,
      _props$ssdtiName = props.ssdtiName,
      ssdtiName = _props$ssdtiName === void 0 ? 'ssdti' : _props$ssdtiName,
      _props$ssdcpName = props.ssdcpName,
      ssdcpName = _props$ssdcpName === void 0 ? 'ssdcp' : _props$ssdcpName,
      _props$ssdgeName = props.ssdgeName,
      ssdgeName = _props$ssdgeName === void 0 ? 'ssdge' : _props$ssdgeName,
      _props$ssdklName = props.ssdklName,
      ssdklName = _props$ssdklName === void 0 ? 'ssdkl' : _props$ssdklName,
      _props$cookiesDomain = props.cookiesDomain,
      cookiesDomain = _props$cookiesDomain === void 0 ? '.s7.ru' : _props$cookiesDomain,
      _props$isModal = props.isModal,
      isModal = _props$isModal === void 0 ? true : _props$isModal,
      _props$isSocial = props.isSocial,
      isSocial = _props$isSocial === void 0 ? false : _props$isSocial,
      isTemporaryProfile = props.isTemporaryProfile,
      _props$stage = props.stage,
      stage = _props$stage === void 0 ? 'qa' : _props$stage,
      _props$theme = props.theme,
      themeProps = _props$theme === void 0 ? 'b2c' : _props$theme,
      socialState = props.socialState,
      _props$socialApple = props.socialApple,
      socialAppleProp = _props$socialApple === void 0 ? false : _props$socialApple,
      _props$socialFacebook = props.socialFacebook,
      socialFacebookProp = _props$socialFacebook === void 0 ? false : _props$socialFacebook,
      _props$socialGoogle = props.socialGoogle,
      socialGoogleProp = _props$socialGoogle === void 0 ? true : _props$socialGoogle,
      _props$socialLogin = props.socialLogin,
      socialLoginProp = _props$socialLogin === void 0 ? true : _props$socialLogin,
      socialLoginParameters = props.socialLoginParameters,
      _props$socialOneTap = props.socialOneTap,
      socialOneTap = _props$socialOneTap === void 0 ? true : _props$socialOneTap,
      _props$socialTinkoff = props.socialTinkoff,
      socialTinkoffProp = _props$socialTinkoff === void 0 ? false : _props$socialTinkoff,
      _props$socialVk = props.socialVk,
      socialVkProp = _props$socialVk === void 0 ? true : _props$socialVk,
      _props$socialYandex = props.socialYandex,
      socialYandexProp = _props$socialYandex === void 0 ? true : _props$socialYandex,
      socialButtonsVisible = props.socialButtonsVisible,
      _props$oneTap = props.oneTap,
      oneTap = _props$oneTap === void 0 ? {
    delay: 3000,
    doNotShowDays: 1
  } : _props$oneTap,
      temporaryResource = props.temporaryResource,
      _props$isRecovery = props.isRecovery,
      isRecovery = _props$isRecovery === void 0 ? false : _props$isRecovery,
      recoveryHref = props.recoveryHref,
      _props$loginDisabled = props.loginDisabled,
      loginDisabled = _props$loginDisabled === void 0 ? false : _props$loginDisabled,
      loginHref = props.loginHref,
      loginHeaderText = props.loginHeaderText,
      loginBottomText = props.loginBottomText,
      loginButtonText = props.loginButtonText,
      info = props.info,
      _props$headers = props.headers,
      headers = _props$headers === void 0 ? {} : _props$headers,
      headingColor = props.headingColor,
      _props$openRecoveryIn = props.openRecoveryInNewTab,
      openRecoveryInNewTab = _props$openRecoveryIn === void 0 ? false : _props$openRecoveryIn,
      isOpenProp = props.isOpen,
      _props$login = props.login,
      loginProp = _props$login === void 0 ? '' : _props$login,
      recoveryStep = props.recoveryStep,
      recoverySecret = props.recoverySecret,
      isAllowedDataIds = props.isAllowedDataIds,
      withoutCast = props.withoutCast,
      _props$posGA = props.posGA,
      posGA = _props$posGA === void 0 ? 'EMPTY' : _props$posGA,
      titleSize = props.titleSize,
      _props$fetchCampaigns = props.fetchCampaigns,
      fetchCampaigns = _props$fetchCampaigns === void 0 ? false : _props$fetchCampaigns,
      onRecoverySuccess = props.onRecoverySuccess,
      showSuccessRecoverPopupOnMount = props.showSuccessRecoverPopupOnMount,
      loginFieldProps = props.loginFieldProps,
      passwordFieldProps = props.passwordFieldProps,
      _props$providerSwitch = props.providerSwitcher,
      providerSwitcher = _props$providerSwitch === void 0 ? false : _props$providerSwitch,
      registerButtonText = props.registerButtonText,
      onRegister = props.onRegister,
      oneSignalUserId = props.oneSignalUserId,
      others = _objectWithoutProperties(props, _excluded2);

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      login = _useState2[0],
      setLogin = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      loginTooltip = _useState4[0],
      setLoginTooltip = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      password = _useState6[0],
      setPassword = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      passwordTooltip = _useState8[0],
      setPasswordTooltip = _useState8[1];

  var _useState9 = useState(''),
      _useState10 = _slicedToArray(_useState9, 2),
      formattedLogin = _useState10[0],
      setFormattedLogin = _useState10[1];

  var _useState11 = useState(''),
      _useState12 = _slicedToArray(_useState11, 2),
      nonFormattedLogin = _useState12[0],
      setNonFormattedLogin = _useState12[1];

  var _useState13 = useState({}),
      _useState14 = _slicedToArray(_useState13, 2),
      socialProfileData = _useState14[0],
      setSocialProfileData = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      socialEmailAlreadyUsed = _useState16[0],
      setSocialEmailAlreadyUsed = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      socialPhoneAlreadyUsed = _useState18[0],
      setSocialPhoneAlreadyUsed = _useState18[1];

  var _useState19 = useState(''),
      _useState20 = _slicedToArray(_useState19, 2),
      socialToken = _useState20[0],
      setSocialToken = _useState20[1];

  var _useState21 = useState(null),
      _useState22 = _slicedToArray(_useState21, 2),
      error = _useState22[0],
      setError = _useState22[1];

  var _useState23 = useState(isRecovery),
      _useState24 = _slicedToArray(_useState23, 2),
      isRecoveryModal = _useState24[0],
      setIsRecoveryModal = _useState24[1];

  var _useState25 = useState(''),
      _useState26 = _slicedToArray(_useState25, 2),
      popupText = _useState26[0],
      setPopupText = _useState26[1];

  var _useState27 = useState(loginDisabled),
      _useState28 = _slicedToArray(_useState27, 2),
      loginButtonDisabled = _useState28[0],
      setDisabledLoginButton = _useState28[1];

  var _useState29 = useState(themeProps),
      _useState30 = _slicedToArray(_useState29, 2),
      theme = _useState30[0],
      setTheme = _useState30[1];

  var _useState31 = useState(isOpenProp || false),
      _useState32 = _slicedToArray(_useState31, 2),
      isOpen = _useState32[0],
      setIsOpen = _useState32[1];

  var _useState33 = useState(socialAppleProp),
      _useState34 = _slicedToArray(_useState33, 2),
      socialApple = _useState34[0],
      setSocialApple = _useState34[1];

  var _useState35 = useState(socialFacebookProp),
      _useState36 = _slicedToArray(_useState35, 2),
      socialFacebook = _useState36[0],
      setSocialFacebook = _useState36[1];

  var _useState37 = useState(socialGoogleProp),
      _useState38 = _slicedToArray(_useState37, 2),
      socialGoogle = _useState38[0],
      setSocialGoogle = _useState38[1];

  var _useState39 = useState(socialLoginProp),
      _useState40 = _slicedToArray(_useState39, 2),
      socialLogin = _useState40[0],
      setSocialLogin = _useState40[1];

  var _useState41 = useState(socialTinkoffProp),
      _useState42 = _slicedToArray(_useState41, 2),
      socialTinkoff = _useState42[0],
      setSocialTinkoff = _useState42[1];

  var _useState43 = useState(socialVkProp),
      _useState44 = _slicedToArray(_useState43, 2),
      socialVk = _useState44[0],
      setSocialVk = _useState44[1];

  var _useState45 = useState(socialYandexProp),
      _useState46 = _slicedToArray(_useState45, 2),
      socialYandex = _useState46[0],
      setSocialYandex = _useState46[1];

  var _useState47 = useState(''),
      _useState48 = _slicedToArray(_useState47, 2),
      token = _useState48[0],
      setToken = _useState48[1];

  var _useState49 = useState(null),
      _useState50 = _slicedToArray(_useState49, 2),
      twoFactorDetails = _useState50[0],
      setTwoFactorDetails = _useState50[1];

  var _useState51 = useState(null),
      _useState52 = _slicedToArray(_useState51, 2),
      loginBlockState = _useState52[0],
      setLoginBlockState = _useState52[1];

  var timeoutId = useRef(null); // 'email|phone|ffp|google|vk|tinkoff|yandex'

  var loginType = useRef('');
  var isLoginTouched = useRef(false);
  var sendGARef = useRef(noop);
  var dictionary = useMemo(function () {
    return getDictionary(language);
  }, [language]);
  var breakpoints = useMediaQuery('smMin');
  var isDesktop = breakpoints.smMin;

  var _useAnalyticsContext = useAnalyticsContext(),
      sendEvent = _useAnalyticsContext.sendEvent;

  var clearPopup = function clearPopup() {
    return setPopupText('');
  };

  var _ref2 = others,
      _ref2$title = _ref2.title,
      title = _ref2$title === void 0 ? dictionary.t('com.login.title') : _ref2$title;
  var socialEmail = socialProfileData.email,
      socialPhone = socialProfileData.phone,
      socialName = socialProfileData.name,
      socialType = socialProfileData.type;
  var overflow = React.useMemo(function () {
    return document.body.style.overflow;
  }, []);
  var isStageProxy = stage === 'proxy';
  var getTestId = useMemo(function () {
    return isAllowedDataIds ? getTestIdGetter(dictKeys.LOGIN) : function () {
      return {};
    };
  }, [isAllowedDataIds]);
  var sendGA = useCallback(isStageProxy ? sendMyProfileLoginEvent : sendMyProfileLoginWidgetEvent(posGA), [isStageProxy]);

  var handleClose = function handleClose() {
    setIsOpen(false);

    if (typeof onClose === 'function') {
      onClose();
    }

    setLogin('');
    setLoginTooltip('');
    setPassword('');
    setPasswordTooltip('');
    setFormattedLogin('');
    setNonFormattedLogin('');
    setSocialProfileData({});
    setSocialEmailAlreadyUsed(false);
    setSocialPhoneAlreadyUsed(false);
    setSocialToken('');
    setError(null);
    setIsRecoveryModal(isRecovery);
    setPopupText('');

    if (typeof window !== 'undefined' && window.lwapi) {
      while (window.lwapi.callback.length) {
        var _window$lwapi$callbac;

        (_window$lwapi$callbac = window.lwapi.callback.pop()) === null || _window$lwapi$callbac === void 0 ? void 0 : _window$lwapi$callbac();
      }
    }
  };

  useInitLWAPI({
    isOpen: isOpen,
    setIsOpen: setIsOpen,
    ssdcpName: ssdcpName,
    handleClose: handleClose
  });
  useEffect(function () {
    setStage(stage);
    sendGARef.current = sendGA;
    setCounterId(stage);
  }, [stage]);
  useEffect(function () {
    setLanguage(language);
  }, [language]);
  useEffect(function () {
    setHeaders(headers);
  }, [headers]);
  useEffect(function () {
    if (showSuccessRecoverPopupOnMount) {
      showSuccessRecoverPopup();
    }
  }, []);
  useEffect(function () {
    setIsOpen(isOpenProp || false);
  }, [isOpenProp]);
  useEffect(function () {
    setTheme(themeProps);
  }, [themeProps]);
  useEffect(function () {
    setDisabledLoginButton(loginDisabled);
  }, [loginDisabled]);
  useEffect(function () {
    if (isModal && isOpen) {
      document.body.style.overflow = 'hidden';
      document.body.setAttribute('style', 'overflow: hidden;');
      sendGA({
        eventActionPath: ['onOpen']
      });
      return function () {
        document.body.style.overflow = overflow;
      };
    }

    document.body.setAttribute('style', "overflow: ".concat(isOpen && isModal ? 'hidden' : overflow, ";"));
    return noop;
  }, [isOpen, isModal]);
  useEffect(function () {
    var handleMouseClick = function handleMouseClick(e) {
      if (pathOr('', ['currentTarget', 'id'], e) === 'continue-as' && pathOr('', ['currentTarget', 'baseURI'], e).startsWith('https://accounts.google.com')) {
        sendGARef.current = _objectSpread(_objectSpread({}, sendGARef.current), {}, {
          eventActionPath: ['onClickSocial'],
          eventLabel: "SOCIAL:".concat(typesMapGA.oneTap)
        });
      }
    };

    if (socialLogin) {
      initSocials(socialLoginParameters, {
        socialApple: socialApple,
        socialFacebook: socialFacebook,
        socialGoogle: socialGoogle,
        socialTinkoff: socialTinkoff,
        socialVk: socialVk,
        socialYandex: socialYandex
      });

      if (socialFacebook) {
        appendFacebookPlaceholderNode();
      }

      appendSocialAuthScripts({
        socialApple: socialApple,
        socialFacebook: socialFacebook,
        socialGoogle: socialGoogle
      });
      window.addEventListener('click', handleMouseClick);

      if (!isStageProxy) {
        getAllowedSocials().then(function (res) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          var allowedSocials = propOr({}, ['data'], res);

          if (!allowedSocials.auth) {
            setSocialLogin(false);
          }

          if (socialApple && !allowedSocials.apple) {
            setSocialApple(false);
          }

          if (socialFacebook && !allowedSocials.facebook) {
            setSocialFacebook(false);
          }

          if (socialGoogle && !allowedSocials.google) {
            setSocialGoogle(false);
          }

          if (socialTinkoff && !allowedSocials.tinkoff) {
            setSocialTinkoff(false);
          }

          if (socialVk && !allowedSocials.vkontakte) {
            setSocialVk(false);
          }

          if (setSocialYandex && !allowedSocials.yandex) {
            setSocialYandex(false);
          }
        });
      }
    }

    return function () {
      if (cancelSource) {
        cancelSource.cancel('Canceled since the component is unmounted');
      }

      if (timeoutId.current) {
        clearInterval(timeoutId.current);
      }

      if (socialLogin) {
        window.removeEventListener('click', handleMouseClick);
      }
    };
  }, []);
  useEffect(function () {
    if (socialState) {
      var stateError = socialState.error,
          _token = socialState.token,
          type = socialState.type;
      setSocialToken(_token);
      handleSocialLoginFailure(stateError, // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      typesMap[type] ? type : type.toLowerCase());
    }
  }, [socialState]);
  useInitCast({
    withoutCast: withoutCast,
    isTemporaryProfile: isTemporaryProfile,
    ssdtpName: ssdtpName,
    ssdtiName: ssdtiName,
    ssdcpName: ssdcpName,
    stage: stage,
    onLoginTemporary: onLoginTemporary,
    onLoginError: onLoginError,
    onCastSuccess: onCastSuccess,
    cookiesDomain: cookiesDomain
  });

  var handleFormatLogin = function handleFormatLogin(value) {
    var _formatLogin = formatLogin(value),
        formatted = _formatLogin.formattedLogin,
        nonFormatted = _formatLogin.loginWithoutMask,
        type = _formatLogin.type;

    loginType.current = loginTypes[type];
    setLogin(value);
    setFormattedLogin(formatted);
    setNonFormattedLogin(nonFormatted);
  };

  useEffect(function () {
    handleFormatLogin(loginProp);
  }, [loginProp]);
  var validateLogin = useCallback(getLoginValidator({
    dictionary: dictionary,
    tooltipSetter: setLoginTooltip
  }), []);
  useEffect(function () {
    var fields = [];

    if (loginTooltip) {
      fields.push("LGN:".concat(loginTooltip));
    }

    if (passwordTooltip) {
      fields.push("PSW:".concat(passwordTooltip));
    }

    if (fields.length) {
      sendGA({
        eventActionPath: ['onSubmitError'],
        eventLabel: "VALIDATE:client;".concat(fields.join(';'), ";TYPE:").concat(loginTypesGA[loginType.current])
      });
    }
  }, [loginTooltip, passwordTooltip]);

  var handlePasswordChange = function handlePasswordChange(event) {
    setPassword(event.target.value);
    setPasswordTooltip('');
    setError(null);
  };

  var handlePasswordFocus = function handlePasswordFocus(e) {
    var input = e.currentTarget;

    if (isHtmlInputElement(input)) {
      input.value = '';
    }
  };

  var handleLoginChange = function handleLoginChange(event) {
    var value = event.target.value;
    handleFormatLogin(value);
    setError(null);

    if (isLoginTouched.current) {
      validateLogin(value);
    }
  };

  var handleLoginBlur = function handleLoginBlur() {
    if (!isLoginTouched.current) {
      isLoginTouched.current = true;
      validateLogin(login);
    }

    setLogin(formattedLogin);
  };

  var handleLoginFocus = function handleLoginFocus(e) {
    setLogin(nonFormattedLogin);
    var input = e.currentTarget;
    input.value = '';
  };

  var handleRecoveryBlur = function handleRecoveryBlur() {
    return setLogin(formattedLogin);
  };

  var handleLoginMessage = function handleLoginMessage(data) {
    onLoginSuccess(data);
    sendGA({
      eventActionPath: ['onSubmitSuccessOnProfile'],
      userId: data.id
    });
    setDisabledLoginButton(false);

    if (typeof onClose === 'function') {
      onClose();
    }

    if (typeof window !== 'undefined' && window.lwapi) {
      while (window.lwapi.callback.length) {
        var _window$lwapi$callbac2;

        (_window$lwapi$callbac2 = window.lwapi.callback.pop()) === null || _window$lwapi$callbac2 === void 0 ? void 0 : _window$lwapi$callbac2(data);
        setIsOpen(false);
      }
    }
  };

  var handleLoginSuccess = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
      var token, resourceid, type, _JSON$parse, ssdkl, data, promises, errorObj;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              token = pathOr(null, ['data', 'ticket', 'token'], res);
              resourceid = pathOr(null, ['data', 'ticket', 'resourceId'], res);
              type = pathOr('SHORT', ['data', 'ticket', 'profile', 'type'], res);
              _JSON$parse = JSON.parse(pathOr('', ['config', 'data'], res)), ssdkl = _JSON$parse.device;
              data = {
                id: resourceid,
                token: token
              };

              if (ssdkl) {
                data.ssdkl = ssdkl;
                Cookies.set(ssdklName, ssdkl, _objectSpread(_objectSpread({}, cookiesDomain ? {
                  domain: cookiesDomain
                } : {}), {}, {
                  expires: 3650,
                  path: '/'
                }));
                localStorage.setItem('ssdkl', ssdkl);
                sessionStorage.setItem('ssdkl', ssdkl);
              }

              if (token) {
                data.ssdge = getSsdge(token);
                Cookies.set(ssdcpName, token, _objectSpread(_objectSpread({}, cookiesDomain ? {
                  domain: cookiesDomain
                } : {}), {}, {
                  expires: 30,
                  path: '/'
                })); // TODO: PS-5475
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore

                Cookies.set('userId', resourceid, _objectSpread(_objectSpread({}, cookiesDomain ? {
                  domain: cookiesDomain
                } : {}), {}, {
                  expires: 3650,
                  path: '/'
                })); // TODO: PS-5475
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore

                Cookies.set(ssdgeName, data.ssdge, _objectSpread(_objectSpread({}, cookiesDomain ? {
                  domain: cookiesDomain
                } : {}), {}, {
                  expires: 3650,
                  path: '/'
                }));
                Cookies.remove('ssdtp', _objectSpread(_objectSpread({}, cookiesDomain ? {
                  domain: cookiesDomain
                } : {}), {}, {
                  path: '/'
                }));
                Cookies.remove('ssdti', _objectSpread(_objectSpread({}, cookiesDomain ? {
                  domain: cookiesDomain
                } : {}), {}, {
                  path: '/'
                }));
                promises = [];

                if (withProfile || withLoyalty) {
                  promises.push(Auth.profile(resourceid, {
                    'X-Token': token
                  }));
                } else {
                  handleLoginMessage(data);
                } // TODO: PS-5475
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore


                if (withLoyalty && type === 'FULL') {
                  promises.push(Auth.loyalty(resourceid, {
                    'X-Token': token
                  }));
                }

                if (withProfile || withLoyalty) {
                  Promise.allSettled(promises).then(function (_ref4) {
                    var _ref5 = _slicedToArray(_ref4, 2),
                        resProfile = _ref5[0],
                        resLoyalty = _ref5[1];

                    var loginMessage = _objectSpread({}, data);

                    var profile = pathOr(null, ['value', 'data', 'profile'], resProfile);
                    var loyalty = pathOr(null, ['value', 'data', 'profile'], resLoyalty);

                    if (profile) {
                      loginMessage.profile = profile;
                    }

                    if (loyalty) {
                      loginMessage.loyalty = loyalty;
                    }

                    handleLoginMessage(loginMessage);
                  }).catch(function (err) {
                    handleLoginMessage(_objectSpread(_objectSpread({}, data), {}, {
                      profileError: err
                    }));
                  });
                }

                sendEvent({
                  event: 'login',
                  flow: 'login',
                  step: 'profile_main',
                  type: loginType.current,
                  way: socialEmailAlreadyUsed || socialPhoneAlreadyUsed ? 'profile_already_exists' : 'init'
                });

                if (window.google && window.google.accounts) {
                  window.google.accounts.id.cancel();
                }
              } else {
                errorObj = getErrorFromResponse(res);
                onLoginError(propOr(null, 'data', res));
                setDisabledLoginButton(false);
                sendEvent({
                  error: 'login',
                  event: 'error',
                  flow: 'login',
                  id: errorObj === null || errorObj === void 0 ? void 0 : errorObj.code,
                  item_name: errorObj === null || errorObj === void 0 ? void 0 : errorObj.message,
                  step: 'profile_main',
                  type: 'service'
                });
              }

              if (!(socialEmailAlreadyUsed || socialPhoneAlreadyUsed)) {
                _context.next = 15;
                break;
              }

              _context.prev = 8;
              _context.next = 11;
              return Auth.linkSocialAccount(resourceid, {
                'X-Token': token
              }, {
                token: socialToken,
                type: socialType ? typesMap[socialType] : ''
              });

            case 11:
              _context.next = 15;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](8);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[8, 13]]);
    }));

    return function handleLoginSuccess(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleLoginFailure = function handleLoginFailure(err) {
    var errorObj = getErrorFromResponse(err);

    if ((errorObj === null || errorObj === void 0 ? void 0 : errorObj.code) === 'PROFILE.LOGIN.permanent.blocked') {
      setLoginBlockState({
        blockType: 'permanent',
        message: errorObj === null || errorObj === void 0 ? void 0 : errorObj.message
      });
    }

    if ((errorObj === null || errorObj === void 0 ? void 0 : errorObj.code) === 'PROFILE.LOGIN.blocked') {
      setLoginBlockState({
        blockType: 'temporary',
        message: errorObj === null || errorObj === void 0 ? void 0 : errorObj.message
      });
    }

    setError(errorObj);
    onLoginError(errorObj);
    setDisabledLoginButton(false);
    sendEvent({
      error: 'click_submit',
      event: 'error',
      flow: 'login',
      id: errorObj === null || errorObj === void 0 ? void 0 : errorObj.code,
      item_name: errorObj === null || errorObj === void 0 ? void 0 : errorObj.message,
      step: 'init',
      type: 'service'
    });
  };

  var handleSocialLoginFailure = function handleSocialLoginFailure(err, type) {
    var errorObj = getErrorFromResponse(err) || err;

    if (isProfileExistError(errorObj)) {
      var socialData = getSocialProfileData(errorObj.details);
      var hasProfileByPhone = isProfileExistByPhoneError(errorObj);

      if (hasProfileByPhone) {
        setSocialPhoneAlreadyUsed(true);

        if (socialData && socialData.phone) {
          handleFormatLogin(socialData.phone);
          setError(null);
          validateLogin(socialData.phone);
          setPassword('');
          loginType.current = loginTypes.phone;
        }
      } else {
        setSocialEmailAlreadyUsed(true);

        if (socialData && socialData.email) {
          handleFormatLogin(socialData.email);
          setError(null);
          validateLogin(socialData.email);
          setPassword('');
          loginType.current = loginTypes.email;
        }
      }

      if (socialData && (socialData.email || socialData.phone)) {
        setSocialProfileData(_objectSpread(_objectSpread({}, socialData), {}, {
          type: loginTypes[type]
        }));
        errorObj = {
          code: errorObj.code
        };
      }

      sendGA({
        eventActionPath: ['onOpenSocialLoginFound'],
        eventLabel: "SOCIAL:".concat(typesMapGA[type])
      });
    }

    setError(errorObj);
  };

  var handleSubmit = function handleSubmit() {
    var ssdti = Cookies.get(ssdtiName);

    if (!login || !password) {
      if (!login) {
        setLoginTooltip(dictionary.t('com.validation.required'));
      }

      if (!password) {
        setPasswordTooltip(dictionary.t('com.validation.required'));
      }

      return;
    }

    if (loginType.current !== loginTypes.email && nonFormattedLogin.length < 9) {
      setLoginTooltip(dictionary.t('com.validation.minlength9'));
      return;
    }

    if (loginType.current === loginTypes.email && !validateEmail(nonFormattedLogin)) {
      setLoginTooltip(dictionary.t('com.validation.email.invalid'));
      return;
    }

    setDisabledLoginButton(true);
    Auth.login({
      id: nonFormattedLogin,
      secret: password,
      temporaryResource: temporaryResource || ssdti
    }, {
      headers: {
        'x-push-id': oneSignalUserId,
        platform: 'WEB'
      }
    }).then(function (res) {
      var token = pathOr('', ['data', 'ticket', 'token'], res);
      setToken(token);
      var twoFactorDetails = pathOr(null, ['data', 'ticket', 'twoFactorDetails'], res);
      setTwoFactorDetails(twoFactorDetails);

      if (twoFactorDetails) {
        return;
      }

      return new Promise(function (resolve) {
        var resourceid = pathOr(null, ['data', 'ticket', 'resourceId'], res);

        if (socialEmailAlreadyUsed || socialPhoneAlreadyUsed) {
          Auth.linkSocialAccount(resourceid, {
            'X-Token': token
          }, {
            token: socialToken,
            type: socialType ? typesMap[socialType] : ''
          });
        }

        if (fetchCampaigns) {
          return Campaigns.getCampaignsByProfileId(resourceid, {
            'X-Token': token
          }).then(function (_ref6) {
            var data = _ref6.data;
            return _objectSpread(_objectSpread({}, res), {}, {
              data: _objectSpread(_objectSpread({}, res.data), data)
            });
          }).catch(function (campaignsError) {
            // eslint-disable-next-line no-console
            console.log(campaignsError);
            resolve(res);
          });
        }

        return resolve(res);
      }).then(handleLoginSuccess);
    }).catch(handleLoginFailure).finally(function () {
      return setDisabledLoginButton(false);
    });
    sendEvent({
      event: 'click_submit',
      flow: 'login',
      step: 'init',
      type: loginType.current,
      ux_ui: isModal ? 'popup' : 'on_screen'
    });
  };

  var handleSocialLogin = function handleSocialLogin(type) {
    var autoCreate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return function () {
      var ssdti = Cookies.get(ssdtiName);

      if (type !== 'oneTap') {
        sendGA({
          eventActionPath: ['onClickSocial'],
          eventLabel: "SOCIAL:".concat(typesMapGA[type])
        });
      }

      socialAuth(type, {
        oneTap: oneTap,
        sendGA: sendGA,
        stage: stage
      }, function (data) {
        setSocialToken(data.token);
        Auth.socialLogin(_objectSpread(_objectSpread(_objectSpread({
          autoCreate: autoCreate,
          temporaryResource: temporaryResource || ssdti,
          type: typesMap[type]
        }, data.email && {
          email: data.email
        }), data.name && {
          name: data.name
        }), {}, {
          token: data.token
        })).then(function (res) {
          loginType.current = loginTypes[type];
          handleLoginSuccess(res);
        }).catch(function (err) {
          handleSocialLoginFailure(err, type);
        });
      });
    };
  };

  var handleSocialLoginAutoCreate = function handleSocialLoginAutoCreate() {
    sendEvent({
      event: 'click_submit',
      flow: 'login',
      step: 'profile_already_exists',
      type: socialType
    });
    Auth.socialLogin({
      autoCreate: true,
      token: socialToken,
      type: socialType ? typesMap[socialType] : ''
    }).then(handleLoginSuccess).catch(handleLoginFailure);
  };

  var showSuccessRecoverPopup = function showSuccessRecoverPopup() {
    setPopupText(dictionary.t('com.recover.success_message'));
    timeoutId.current = setTimeout(function () {
      setPopupText('');
    }, 3000);
  };

  var openRecover = function openRecover() {
    setIsRecoveryModal(true);
    setPassword('');
  };

  var resetTwoFactorStates = function resetTwoFactorStates() {
    setError(null);
    setTwoFactorDetails(null);
    setLoginBlockState(null);
  };

  useEffect(function () {
    if (isModal && isOpen) {
      sendEvent({
        event: 'view_screen',
        flow: 'login',
        step: 'init',
        ux_ui: 'popup'
      });
    }

    if (!isOpen) {
      resetTwoFactorStates();
    }
  }, [isOpen]);
  useEffect(function () {
    if (!isModal) {
      sendEvent({
        event: 'view_screen',
        flow: 'login',
        step: 'init',
        ux_ui: 'on_screen'
      });
    }

    return function () {
      resetTwoFactorStates();
    };
  }, []);
  return /*#__PURE__*/React.createElement(AnalyticsContextProvider, null, !isRecoveryModal ? /*#__PURE__*/React.createElement(Login, {
    fields: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Textfield, _extends({}, loginFieldProps, {
      inputProps: getTestId('login'),
      invalid: Boolean(loginTooltip) || Boolean(error && !isProfileExistError(error)),
      label: dictionary.t('com.login.form.login'),
      name: "login",
      onBlur: handleLoginBlur,
      onChange: handleLoginChange,
      onFocus: handleLoginFocus,
      theme: theme,
      tooltip: loginTooltip,
      value: login
    })), /*#__PURE__*/React.createElement(Textfield, _extends({}, passwordFieldProps, {
      inputProps: getTestId('password'),
      invalid: Boolean(passwordTooltip) || Boolean(error && !isProfileExistError(error)),
      label: dictionary.t('com.login.form.password'),
      name: "password",
      onChange: handlePasswordChange,
      onFocus: handlePasswordFocus,
      theme: theme,
      tooltip: passwordTooltip,
      type: "password",
      value: password
    }))),
    footer: loginBottomText,
    heading: loginHeaderText,
    headingColor: headingColor,
    isDesktop: isDesktop,
    isOpen: isOpen || !isModal,
    loginDisabled: loginButtonDisabled,
    loginText: loginButtonText || dictionary.t('com.login.submit'),
    notification: error ? error.message : undefined,
    notificationTitle: undefined,
    onClickApple: socialApple ? handleSocialLogin('apple') : undefined,
    onClickFB: socialFacebook ? handleSocialLogin('fb') : undefined,
    onClickGoogle: socialGoogle ? handleSocialLogin('google') : undefined,
    onClickOneTap: socialOneTap ? handleSocialLogin('oneTap') : undefined,
    onClickTinkoff: socialTinkoff ? handleSocialLogin('tinkoff') : undefined,
    onClickVK: socialVk ? handleSocialLogin('vk') : undefined,
    onClickYandex: socialYandex ? handleSocialLogin('yandex') : undefined,
    onClose: isModal ? handleClose : null,
    onLogin: handleSubmit,
    onRecover: openRecover,
    onRegister: onRegister,
    popup: popupText ? /*#__PURE__*/React.createElement(Popup, _extends({
      clearPopup: clearPopup,
      text: popupText
    }, getTestId('passwordRecoveryPopup'))) : null,
    providerSwitcher: providerSwitcher,
    recoveryText: dictionary.t('com.login.recovery'),
    registrationText: registerButtonText || [/*#__PURE__*/React.createElement(UserLinear, {
      key: 0
    }), dictionary.t('com.login.registration')],
    socialButtonsDisable: !socialLogin,
    socialButtonsTitle: dictionary.t('com.login.social'),
    socialButtonsVisible: socialButtonsVisible,
    socialEmailAlreadyUsed: socialEmailAlreadyUsed,
    socialEmailFoundText: dictionary.t('com.social.email'),
    socialIgnoreButtonText: dictionary.t('com.social.ignore'),
    socialLoginButtonText: dictionary.t('com.social.login'),
    socialLoginText: dictionary.t('com.social.text'),
    socialOneTapDisable: !socialOneTap,
    socialOnIgnore: handleSocialLoginAutoCreate,
    socialPhoneAlreadyUsed: socialPhoneAlreadyUsed,
    socialPhoneFoundText: dictionary.t('com.social.phone'),
    clearPopup: clearPopup,
    dictionary: dictionary,
    getTestId: getTestId,
    info: info,
    isB2B: isB2B,
    isModal: isModal,
    isSocial: isSocial,
    openRecoveryInNewTab: openRecoveryInNewTab,
    openRegistrationInNewTab: openRegistrationInNewTab,
    recoveryHref: recoveryHref,
    registrationHref: registrationHref,
    sendGA: sendGA,
    socialEmail: socialEmail,
    socialName: socialName,
    socialPhone: socialPhone,
    socialType: socialType,
    theme: theme,
    title: title,
    titleSize: titleSize,
    handleLoginFailure: handleLoginFailure,
    handleLoginSuccess: handleLoginSuccess,
    loginBlockState: loginBlockState,
    onBackFromTwoFactor: resetTwoFactorStates,
    setLoginBlockState: setLoginBlockState,
    setTwoFactorDetails: setTwoFactorDetails,
    token: token,
    twoFactorDetails: twoFactorDetails
  }) : /*#__PURE__*/React.createElement(Recovery, {
    isDesktop: isDesktop,
    isOpen: isOpen || !isModal,
    onBack: function onBack() {
      return setIsRecoveryModal(false);
    },
    onClose: isModal ? handleClose : null,
    onLoginBlur: handleRecoveryBlur,
    onLoginFocus: handleLoginFocus,
    onRecoverySuccess: onRecoverySuccess,
    parentSetError: setError,
    secret: recoverySecret,
    step: recoveryStep,
    dictionary: dictionary,
    handleLoginChange: handleLoginChange,
    headingColor: headingColor,
    isAllowedDataIds: isAllowedDataIds,
    isModal: isModal,
    login: login,
    loginHref: loginHref,
    nonFormattedLogin: nonFormattedLogin,
    showSuccessRecoverPopup: showSuccessRecoverPopup,
    theme: theme
  }));
};
export default LoginWidget;
export { recoverySteps };